import React, { useEffect } from 'react';
import PendoService from '@Services/Pendo';
import { helpUrl } from '@Constants/CommonConstants';
import { Icon } from '@els/els-react--icon';
import PropTypes from 'prop-types';

import './Help.scss';

function Help({ isPendoResourceCenterEnabled }) {
  const doNotTrack = window._doNotTrackBrowser;

  useEffect(() => {
    // Only add window listener to close when clicking outside
    window.addEventListener('click', PendoService.closeResourceCenter);
    return () => {
      window.removeEventListener('click', PendoService.closeResourceCenter);
    };
  }, []);

  const handleHelpClick = (e) => {
    if (isPendoResourceCenterEnabled && !doNotTrack) {
      e.stopPropagation();
    }
  };

  return (
    <li className="u-els-padding-left-1o2">
      <a
        id="main-nav-help-link"
        title="Help"
        aria-label="Help"
        target="_blank"
        href={!isPendoResourceCenterEnabled || doNotTrack ? helpUrl : undefined}
        onClick={handleHelpClick}
        className="u-els-color-n8 vertical-middle rx-btn-help"
        rel="noreferrer">
        <Icon a11y={{ name: 'help' }} id="help-icon" color="default" size="s" sprite="HelpOutlineCircle" />
      </a>
    </li>
  );
}

Help.propTypes = {
  isPendoResourceCenterEnabled: PropTypes.bool,
};

export default Help;
